class Stack {
    private items: any[];

    constructor(initial = []) {
      this.items = [...initial];
    }
  
    push(item) {
      this.items.push(item);
    }
  
    pop() {
      return this.items.pop();
    }
  
    peek() {
      return this.items[this.items.length - 1] || null;
    }
  
    size() {
      return this.items.length;
    }
  
    isEmpty() {
      return this.items.length === 0;
    }

    getItems() {
      return this.items;
    }
  }
  

  export type Path = Array<string | number>;

  interface DiffEntry {
    path: Path;
    value1: any; // value from first object
    value2: any; // value from second object
  }
  
  export function getDifferencesWithValues(
    obj1: any,
    obj2: any,
    path: Path = [],
    result: DiffEntry[] = []
  ): DiffEntry[] {
    const isObject = (val: any): val is object =>
      val !== null && typeof val === "object";
  
    const keys = Array.isArray(obj1)
      ? new Set([...Object.keys(obj1), ...Object.keys(obj2)])
      : new Set([...Object.keys(obj1 || {}), ...Object.keys(obj2 || {})]);
  
    for (const key of Array.from(keys)) {
      const typedKey: string | number = Array.isArray(obj1)
        ? Number(key)
        : key;
  
      const val1 = obj1?.[typedKey];
      const val2 = obj2?.[typedKey];
  
      if (isObject(val1) && isObject(val2)) {
        getDifferencesWithValues(val1, val2, [...path, typedKey], result);
      } else if (val1 !== val2) {
        result.push({
          path: [...path, typedKey],
          value1: val1,
          value2: val2,
        });
      }
    }
  
    return result;
  }
  
  

export default Stack;